export const DEFAULT_CHART_TARGET_BARS = 180;
export const MAX_CHART_TARGET_BARS = 360;
export const MIN_CHART_TARGET_BARS = 2;
const SPACING_BY_DENSITY = {
    line: 3,
    candle: 6,
};
const PRICE_TARGET_TIERS = [32, 48, 64, 96, 128, 180, 240, 360];
export function visibleBarEstimate(plotWidth, density) {
    if (!Number.isFinite(plotWidth) || plotWidth <= 0)
        return MIN_CHART_TARGET_BARS;
    return Math.max(MIN_CHART_TARGET_BARS, Math.min(MAX_CHART_TARGET_BARS, Math.ceil(plotWidth / SPACING_BY_DENSITY[density])));
}
/** Quantize only OHLC-backed chart requests; Market Share keeps its raw estimate. */
export function priceChartTargetBars(plotWidth, density) {
    if (!Number.isFinite(plotWidth) || plotWidth <= 0)
        return DEFAULT_CHART_TARGET_BARS;
    const estimate = visibleBarEstimate(plotWidth, density);
    return PRICE_TARGET_TIERS.reduce((best, tier) => Math.abs(tier - estimate) < Math.abs(best - estimate) ? tier : best);
}
